import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgGreenDollar = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={50}
    height={50}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
      fill="#2CD19E"
      fillOpacity={0.17}
    />
    <path
      d="M25 24.167c-1.406 0-2.552-.782-2.552-1.72 0-.937 1.146-1.718 2.552-1.718.781 0 1.51.26 1.98.677a.882.882 0 0 0 1.197-.052.882.882 0 0 0-.052-1.198c-.573-.52-1.406-.885-2.24-1.041v-.938a.822.822 0 0 0-.833-.833.823.823 0 0 0-.833.833v.938c-1.927.312-3.386 1.666-3.386 3.333 0 1.875 1.928 3.385 4.271 3.385 1.407 0 2.552.782 2.552 1.719 0 .938-1.145 1.719-2.552 1.719-.781 0-1.51-.26-1.979-.677a.882.882 0 0 0-1.198.052.882.882 0 0 0 .052 1.198c.573.52 1.407.885 2.24 1.041v.938c0 .469.364.833.833.833a.823.823 0 0 0 .834-.833v-.938c1.927-.312 3.385-1.666 3.385-3.333 0-1.875-1.927-3.385-4.27-3.385Z"
      fill="#2CD19E"
    />
    <path
      d="M25 40c-8.281 0-15-6.719-15-15 0-8.281 6.719-15 15-15 8.281 0 15 6.719 15 15 0 8.281-6.719 15-15 15Zm0-28.438c-7.396 0-13.438 6.042-13.438 13.438 0 7.396 6.042 13.438 13.438 13.438 7.396 0 13.438-6.042 13.438-13.438 0-7.396-6.042-13.438-13.438-13.438Z"
      fill="#2CD19E"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGreenDollar);
export default ForwardRef;
